import _asyncToGenerator from "/project/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import { computed, defineComponent, reactive, onUnmounted } from 'vue';
import { useService } from '@kaokei/use-vue-service';
import { UserExamService } from '@/services/userExam.service';
import { useRouter, useRoute } from 'vue-router';
import { DaoService } from '@/services/dao.service';
import { USER_EXAM_PASSED, USER_EXAM_AWARDED, QUESTION_TYPE, value2label, formatDateToSecond, preloadIDE } from '@/utils';
import ExamInfoModal from '@/components/ExamInfoModal.vue';
import { environment } from '@/utils/environment';
export default defineComponent({
  name: 'ContestTable',
  components: {
    ExamInfoModal: ExamInfoModal
  },
  props: {
    list: {
      type: Array
    }
  },
  setup: function setup() {
    var route = useRoute();
    var isNocFlag = computed(function () {
      return route.query.platform === 'noc';
    });
    var columns = computed(function () {
      var firstColumn = {
        title: '活动ID',
        dataIndex: 'contestInfoId',
        key: 'contestInfoId',
        fixed: 'left'
      };
      var cols = [{
        title: isNocFlag.value ? '比赛信息' : '活动信息',
        key: 'contestInfo',
        slots: {
          customRender: 'contestInfo'
        },
        width: 200,
        fixed: 'left'
      }, {
        title: isNocFlag.value ? '比赛开始时间' : '考试开始时间',
        key: 'startTime',
        slots: {
          customRender: 'startTime'
        },
        width: 160
      }, {
        title: isNocFlag.value ? '比赛结束时间' : '考试结束时间',
        key: 'endTime',
        slots: {
          customRender: 'endTime'
        },
        width: 160
      }, {
        title: '组别',
        dataIndex: 'contestScheduledName',
        key: 'contestScheduledName',
        width: 200
      }, {
        title: isNocFlag.value ? '比赛阶段' : '活动阶段',
        dataIndex: 'contestStageName',
        key: 'contestStageName',
        width: 100
      }, {
        title: '得分',
        key: 'totalScore',
        slots: {
          customRender: 'totalScore'
        },
        width: 80
      }, {
        title: '晋级结果',
        key: 'passed',
        slots: {
          customRender: 'passed'
        },
        width: 80
      }, {
        title: '奖项',
        key: 'awarded',
        slots: {
          customRender: 'awarded'
        },
        width: 80
      }, {
        title: '操作',
        key: 'operation',
        fixed: 'right',
        slots: {
          customRender: 'operation'
        }
      }];
      return isNocFlag.value ? cols : [firstColumn].concat(cols);
    });
    var router = useRouter();
    var userExamService = useService(UserExamService);
    var daoService = useService(DaoService);

    var getBaseInfoText = function getBaseInfoText(info) {
      var newInfo = [];
      var repeatMap = {};
      info.forEach(function (el) {
        if ([5, 7].includes(+el.questionTypeId)) {
          if (repeatMap['5,7']) {
            repeatMap['5,7'].count += el.count;
            repeatMap['5,7'].questionTypeIds.push(el.questionTypeId);
          } else {
            repeatMap['5,7'] = {
              count: el.count,
              questionTypeId: el.questionTypeId,
              questionTypeIds: [el.questionTypeId]
            };
            newInfo.push(repeatMap['5,7']);
          }
        } else {
          newInfo.push(el);
        }
      });
      return newInfo.map(function (info) {
        return "".concat(info.count, "\u9053").concat(value2label(info.questionTypeId, QUESTION_TYPE));
      }).join('、');
    };

    var checkDetail = function checkDetail(item) {
      router.push({
        name: 'UserItemDetail',
        params: {
          id: item.userExamId
        },
        query: route.query
      });
    };

    var examInfo = reactive({
      userExamId: 0,
      visible: false,
      baseInfoText: '',
      answerRule: '',
      contestId: 0
    });

    var showExamInfo = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(item) {
        var showAction;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                showAction = function showAction() {
                  daoService.getExamInfo(item.userExamId).then(function (info) {
                    examInfo.baseInfoText = getBaseInfoText(info.questionInfoList);
                    examInfo.answerRule = info.answerRule;
                    preloadIDE(); // 预加载ide

                    examInfo.userExamId = item.userExamId;
                    examInfo.visible = true;
                    examInfo.contestId = item.contestInfoId;
                  });
                };

                if (item.examType === 1) {
                  // if (item.userExamId) {
                  daoService.preStartMockExam(item.userExamId).then(function () {
                    showAction();
                  });
                } else {
                  showAction();
                }

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function showExamInfo(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    var onPaginationChange = function onPaginationChange(pa) {
      userExamService.setPageNum(pa.current);
      userExamService.setPageSize(pa.pageSize);
      userExamService.search();
    };

    var pagination = computed(function () {
      return {
        showSizeChanger: true,
        total: userExamService.total,
        current: userExamService.pageNum,
        pageSize: userExamService.pageSize
      };
    });

    var goToItemDetail = function goToItemDetail(item) {
      if (isNocFlag.value) return;
      router.push({
        name: 'ItemDetail',
        params: {
          id: item.contestInfoId
        },
        query: route.query
      });
    };

    var goToExamAnswer = function goToExamAnswer(item) {
      router.push({
        name: 'Examination',
        params: {
          id: item.userExamId,
          answerId: item.answerPaperId
        },
        query: route.query
      });
    };

    var getBtnText = function getBtnText(item) {
      var hideGetCertification = environment === 'production' ? item.contestInfoId === 797 : item.contestInfoId === 36;

      if (item.examType === 1) {
        return '去模拟';
      }

      if (isNocFlag.value) {
        return '去比赛';
      }

      return item.activityId === 259 ? '去比赛' : hideGetCertification ? '参与活动' : '去考试';
    };

    onUnmounted(function () {
      userExamService.clearTimer();
    });

    var getRowClassName = function getRowClassName(record) {
      if (record.status === 1) {
        return 'row-ing';
      }

      if (record.status === 0 && record.endTime < Date.now()) {
        return 'row-ended';
      }

      return '';
    };

    return {
      examInfo: examInfo,
      columns: columns,
      userExamService: userExamService,
      pagination: pagination,
      USER_EXAM_PASSED: USER_EXAM_PASSED,
      USER_EXAM_AWARDED: USER_EXAM_AWARDED,
      value2label: value2label,
      checkDetail: checkDetail,
      showExamInfo: showExamInfo,
      onPaginationChange: onPaginationChange,
      formatDateToSecond: formatDateToSecond,
      goToItemDetail: goToItemDetail,
      goToExamAnswer: goToExamAnswer,
      getBtnText: getBtnText,
      getRowClassName: getRowClassName
    };
  }
});